import { Search } from "lucide-react";
import { T, TYPES, TYPE_ORDER, FOCUS } from "./todoTokens";

const CTRL = `h-[34px] rounded-[8px] text-[13px] bg-white px-2.5 ${FOCUS}`;
const CTRL_EDGE = { border: `1px solid ${T.cardEdge}`, color: T.ink };

/* Directive §6 — type chips left, the other controls right, one wrapping row. */
export const TodoToolbar = ({
  typeFilter, setTypeFilter, typeCounts,
  q, setQ, assignee, setAssignee, assignees,
  client, setClient, clients, group, setGroup,
  filtersActive, shown, openTotal, onClear,
}) => (
  <>
    <div className="flex items-start justify-between gap-3 flex-wrap">
      <div className="flex items-center gap-2 flex-wrap" data-testid="todos-type-chips">
        <Chip on={typeFilter === "all"} onClick={() => setTypeFilter("all")}
          label="All" count={TYPE_ORDER.reduce((n, k) => n + (typeCounts[k] || 0), 0)} testid="todos-type-all" />
        {TYPE_ORDER.map((k) => (
          <Chip key={k} on={typeFilter === k} onClick={() => setTypeFilter(k)}
            label={TYPES[k].plural} count={typeCounts[k] || 0} swatch={TYPES[k]} testid={`todos-type-${k}`} />
        ))}
      </div>

      <div className="flex items-center gap-2 flex-wrap">
        <div className="relative">
          <Search className="w-3.5 h-3.5 absolute left-2.5 top-1/2 -translate-y-1/2" style={{ color: T.muted }} />
          <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search to-dos"
            className={`${CTRL} w-[200px] pl-8`} style={CTRL_EDGE} data-testid="todos-search" />
        </div>
        <select value={assignee} onChange={(e) => setAssignee(e.target.value)}
          className={CTRL} style={CTRL_EDGE} data-testid="todos-assignee">
          <option value="all">All assignees</option>
          <option value="__mine">Just mine</option>
          {assignees.map((a) => <option key={a} value={a}>{a}</option>)}
        </select>
        <select value={client} onChange={(e) => setClient(e.target.value)}
          className={CTRL} style={CTRL_EDGE} data-testid="todos-client">
          <option value="all">All clients</option>
          {clients.map((c) => <option key={c} value={c}>{c}</option>)}
          <option value="__none">No client</option>
        </select>
        <div className="flex items-center gap-1.5">
          <span style={{ fontSize: 10.5, fontWeight: 700, letterSpacing: "0.1em", color: T.muted }}>GROUP</span>
          <div className="flex rounded-[8px] overflow-hidden" style={{ border: `1px solid ${T.cardEdge}` }}>
            {[["due", "Due"], ["assignee", "Assignee"], ["client", "Client"]].map(([k, l]) => (
              <button key={k} onClick={() => setGroup(k)} data-testid={`todos-group-${k}`}
                className="h-[32px] px-2.5 text-[13px] transition-colors"
                style={group === k ? { background: T.accentInk, color: "#fff", fontWeight: 600 }
                  : { background: "#fff", color: T.ink2 }}>{l}</button>
            ))}
          </div>
        </div>
      </div>
    </div>

    {filtersActive && (
      <div className="flex items-center gap-3 text-[12.5px]" data-testid="todos-filter-summary">
        <span style={{ color: T.ink2 }}>
          <span className="mono">{shown}</span> of <span className="mono">{openTotal}</span> open to-dos
        </span>
        <button onClick={onClear} className="font-semibold hover:underline"
          style={{ color: "#8A6D00" }} data-testid="todos-clear-filters">Clear filters</button>
      </div>
    )}
  </>
);

const Chip = ({ on, onClick, label, count, swatch, testid }) => (
  <button onClick={onClick} data-testid={testid}
    className={`h-8 px-3 rounded-full text-[12.5px] font-semibold inline-flex items-center gap-1.5 transition-colors ${FOCUS}`}
    style={on
      ? { background: T.accentInk, color: "#fff", border: `1px solid ${T.accentInk}` }
      : { background: "#fff", color: T.ink2, border: `1px solid ${T.cardEdge}`, opacity: count ? 1 : 0.55 }}>
    {swatch && <span style={{ width: 8, height: 8, borderRadius: 2, background: swatch.fill, border: `1px solid ${swatch.border}` }} />}
    {label}
    <span className="mono text-[11.5px]" style={{ color: on ? T.accent : T.muted }}>{count}</span>
  </button>
);
